module.exports = __webpack_public_path__ + "static/media/img-manner-pet.ef7a4b6b.svg";